
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serp",
      function () {
        return require("private-next-pages/serp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serp"])
      });
    }
  